












import { Component, Vue, Prop, Emit, Watch } from "vue-property-decorator";
import { Getter } from "vuex-class";
import * as _ from "lodash";
import { inventoryCollection, bannersCollection } from "../db";
import * as firebase from "firebase/app";

@Component({})
export default class EquipmentBannerEdit extends Vue {
  @Getter banners;

  @Prop({ required: true })
  public item: any;

  @Prop({ required: true })
  public label: any;

  @Prop({ required: true })
  public value: any;

  private currentBanner: any = null;

  created() {
    if( this.item[this.value] != undefined) {
      this.currentBanner = this.item[this.value];
    }
  }

  async change(banner) {
    const obj = {};
    if (banner != undefined ) {
      obj[this.value] = bannersCollection.doc(banner.id);
    } else {
      obj[this.value] = firebase.firestore.FieldValue.delete();
    }
    await inventoryCollection
        .doc(this.item.id)
        .update(obj);
  }
}
